const urls = {
  cdn: 'https://d2maxvwz12z6fm.cloudfront.net',
  api: 'https://nw5vv3lik8.execute-api.us-east-1.amazonaws.com/legion-hq-api',
  // api: 'http://localhost:3001',
  listPath: 'https://legionhq2.com/list'
};

export default urls;
